import { useLoaderData } from "react-router-dom";
import PageTransition from "./templateParts/PageTransition";
import renderModules from "./renderModules";

const SingleCaseStudy = () => {
  const { modules = [], meta } = useLoaderData();

  return <PageTransition>{renderModules(modules, meta)}</PageTransition>;
};

export default SingleCaseStudy;
